export enum AdminEndpointEnum {
  VALIDATE = "validate",
  ACCOUNTS = "accounts",

  // Account props are now divided into multiple endpoints
  ACCOUNT = "account",
  ACCOUNT_ORDERS = "account/orders",
  ACCOUNT_TRADES = "account/trades",
  ACCOUNT_TXS = "account/txs",
  ACCOUNT_DEGEN_TXS = "degen-txs",
  ACCOUNT_PORTFOLIO = "account/portfolio",
  ACCOUNT_FLOWS = "account/flows",
  ACCOUNT_STATS = "account/stats",
  ACCOUNT_ISOLATED_HEALTH = "account/isolated-health",
  ACCOUNTS_ISOLATED_HEALTH = "accounts/isolated-health",
  ACCOUNT_VOLUME = "account/volume",
  ACCOUNT_STRATEGIES = "account/strategies",
  STRATEGIES = "strategies",
  ACCOUNT_LATENCY = "account-latency",
  SUBACCOUNTS = "subaccounts",

  TRADES = "trade-history",
  ORDER_HISTORY = "account/order-history",
  STOP_ORDER_HISTORY = "account/order-history/stops",
  CANCEL_ALL = "force-cancel-all",
  ACCOUNT_SETTINGS = "account-config",
  GLOBAL_SETTINGS = "asset-config",
  RESTRICTED_COUNTRIES = "restricted-countries",
  SET_USERNAME = "set-username",
  PORTFOLIO_MARGIN = "portfolio-margin",
  CREDIT = "send-credit",
  TRANSFER = "transfer",
  RECOVER = "recover",
  CONFISCATE_BALANCE = "confiscate-balance",
  QUERY_ACCOUNTS = "query-accounts",
  MAINTENANCE = "maintenance",
  PRIORITY_TRANSACTIONS = "priority-transactions",
  RESET_TX_QUEUE = "reset-transactions-queue",
  RESET_ONCHAIN_QUEUE = "reset-onchain-queue",
  SKIP_TRANSACTION = "skip-transaction",
  MANUAL_WITHDRAWS = "manual-withdraws",
  APPROVE_WITHDRAW = "approve-withdraw",
  CANCEL_WITHDRAW = "cancel-withdraw",
  RETURN_OWNERSHIP = "return-ownership",
  CHECK_STATE = "check-state",
  SYNC_STATE = "sync-state",
  RISK_POSITIONS = "risk/positions",
  ACCOUNT_REFERRAL_BONUS = "account/referral-bonus",
  ACCOUNT_REFEREE_DISCOUNT = "account/referee-discount",
  SET_GROUP = "set-group",
  DEBUG = "debug",
  ACCOUNT_TPSL_HISTORY = "account/order-history/tpsl",
  ORDERBOOK_STATE = "orderbook-state",
  ORDERBOOK_STATE_BY_SEQ = "orderbook-state-at-seq",
  CHECK_BALANCE = "account/check",

  AIRTABLE_TAGS = "airtable-tags",
  MANUAL_ACCOUNTS = "manual",
  SET_MANUAL_MODE = "manual-mode",

  REFERRAL = "referral",
  CAMPAIGN_STATS = "campaign-stats",
  LIQUIDATION_PLANS = "liquidation-plans",

  OTC_CREATE_QUOTE = "otc/create-quote",
  OTC_CONFIRM_TRADE = "otc/confirm-trade",

  // Security actions
  PAUSE_INSTRUMENT = "pause-instrument",
  RESUME_INSTRUMENT = "resume-instrument",
  RESUME_ALL_INSTRUMENTS = "resume-all-instruments",
  PAUSE_TRADING = "pause-trading",
  RESUME_TRADING = "resume-trading",
  PAUSE_WITHDRAW = "pause-withdraw",
  RESUME_WITHDRAW = "resume-withdraw",

  // Daily kill switch (cumulative-USD L1 withdrawal cap)
  DAILY_KILL_SWITCH = "daily-kill-switch",
  RESET_DAILY_KILL_SWITCH = "reset-daily-kill-switch",
  DAILY_KILL_SWITCH_THRESHOLD = "daily-kill-switch-threshold",
  DAILY_KILL_SWITCH_USAGE = "daily-kill-switch-usage",

  // Weekly leaderboard reward allocations (per-category AEVO split)
  WEEKLY_REWARD_ALLOCATIONS = "weekly-reward-allocations",

  // Per-source routing of weighted trading volume to reward recipients
  REWARD_VOLUME_ALLOCATIONS = "reward-volume-allocations",

  // Curated perp instrument list for the crypto_majors leaderboard slice
  CRYPTO_MAJORS_INSTRUMENTS = "crypto-majors-instruments",

  // Nerfed MM per-trade VolumeWeight distribution (zero_probability, max_weight)
  NERFED_MM_VOLUME_WEIGHT_PARAMS = "nerfed-mm-volume-weight-params",

  ONDO_SWAPS = "ondo/swaps",
  ONDO_HEDGES = "ondo/hedges",
  ONDO_INVENTORY = "ondo/inventory",

  // Builder Codes V1 (list/create/update builders + protocol fee cap)
  BUILDERS = "builders",
  BUILDER_CONFIG = "builder-config",
}

export enum AevoEndpointEnum {
  CAPACITIES = "socket/capacity",
  MARKETS = "markets",
  MARK_PRICE = "mark-history",
}
export enum DeribitEndpointEnum {
  ACCOUNT_SUMMARY = "account_summary",
  ACCOUNT_POSITIONS = "positions",
  ACCOUNT_TRANSACTIONS = "transactions",
}

export enum BinanceEndpointEnum {
  ACCOUNT_POSITIONS = "positions",
  ACCOUNT_TRANSACTIONS = "transactions",
  ACCOUNT = "account",
}

export enum BybitEndpointEnum {
  ACCOUNT_POSITIONS = "positions",
}

export enum HyperliquidEndpointEnum {
  ACCOUNT_POSITIONS = "positions",
}

export enum LighterEndpointEnum {
  ACCOUNT_POSITIONS = "positions",
}

export enum AirtableEndpointEnum {
  ACCOUNT_TAGS = "tags",
  ACCOUNT_POSITIONS = "positions",
  IF_TRANSACTIONS = "if-transactions",
  MM_PERPS_TRANSACTIONS = "mm-perps-transactions",
  MM_OPTIONS_TRANSACTIONS = "mm-options-transactions",
  FLAGGED_ACCOUNT_NOTES = "notes",
}

export enum PricerEndpointEnum {
  GET_PRICER_TIMESTAMP = "get-timestamp",
  UPDATE_PRICER = "update-pricer",
}

export enum MMTradesEndpointEnum {
  MM_TRADES = "mm-trade-history",
  MARK_PRICE = "mark-price-history",
  TRADES = "trade-history",
  OPTIONS_INSTRUMENTS = "options-instruments",
  OPTIONS_TRADES = "options-trade-history",
  VERTEX_TRADES = "vertex-trade-history",
  PRELAUNCH_TRADES = "prelaunch-trade-history",
  BYBIT_ASSETS = "bybit-assets",
  ACCOUNT_BALANCE_HISTORY = "account-balance-history",
  PERP_DATA_SUMMARY = "perp-data-summary",
}

export enum FilledTradesEndpointEnum {
  FILLED_TRADES = "filled-trades",
  STAKERS_TRADES = "stakers-trades",
  STORE_EPOCH_STAKE = "store-epoch-stake",
  STAKE_HISTORY = "stake-history",
  TRADE_HISTORY = "trade-history",
  STORE_BUYBACK_AND_BURNS = "store-buybacks-and-burns",
  BUYBACKS_AND_BURNS = "buybacks-and-burns",
}

export enum IntercomEndpointEnum {
  CONVERSATIONS = "conversations",
}

export enum MMMonitoringEndpointEnum {
  START = "start",
  STOP = "stop",
  RESTART = "restart",
  STATUS = "status",
  STOP_ALL = "stop-all",
  RESTART_ALL = "restart-all",
}

export enum TradingParametersEndpointEnum {
  GET_TRADING_PARAMETERS = "get-trading-parameters",
  UPDATE_TRADING_PARAMETERS = "update-trading-parameters",
}

export enum WithdrawalsEndpointEnum {
  TODAY = "today",
}

export enum PageEndpointEnum {
  MAKERS = "/makers",
  AFFILIATES = "/affiliates",
  DASHBOARD = "/",
  ACCOUNT = "/account",
  BOOK = "/book",
  JSON = "/json/*",
  TX = "/tx",
  WITHDRAW = "/withdraw",
  SETTINGS = "/settings",
  GEOLOCATIONS = "/geolocations",
  RISK = "/risk",
  ISOLATED_RISK_MONITOR = "/isolated-risk-monitor",
  MMTRADES = "/mm-trades",
  OPTIONSTRADES = "/options-trades",
  MMSTRATEGIES = "mm-strategies",
  DEBUG = "/debug",
  LIVE_TRADES = "/live-trades",
  VOLUME = "/volume",
  INTERCOM = "/intercom",
  CAMPAIGNS = "/campaigns",
  OTC = "/otc",
  SECURITY = "/security",
  REWARDS = "/rewards",
  STAKE = "/stake",
  MM_MONITORING = "/mm-monitoring",
  MM_CONTROL_PANEL = "/mm-control-panel",
  TRADING_PARAMETERS = "/trading-parameters",
  PNL = "/pnl",
  EQUITY = "/equity",
  PERP_DATA = "/perp-data",
  ONDO = "/ondo",
  BUILDERS = "/builders",
  STRATEGIES = "/strategies",
}
